import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import DropDownMenu, { MenuOption } from '@/common/components/DropDownMenu'
import EllipsisIcon from '@/common/components/icons/EllipsisIcon'
import { resolvePath } from '@/common/utils/url'
import { OwnerListingsActionContext } from '@/modules/me/pages/OwnerListingsPage/context'
import {
  SEE_PLACE_DETAILS,
  EDIT_RENTAL_DETAILS,
  EDIT_LISTING,
  DELETE_LISTING,
  MAKE_AS_RENTED,
  MAKE_AS_AVAILABLE,
} from '@/modules/me/pages/OwnerListingsPage/translation'
import { ME_OWNER_LISTING_EDIT_PATH } from '@/modules/me/paths'
import { ROOM_DETAIL_PATH } from '@/modules/property/paths'

interface OwnerListingsActionProps {
  room: RentAPerfect.OwnerRoom
}

const OwnerListingsAction = ({ room }: OwnerListingsActionProps) => {
  const navigate = useNavigate()
  const { setAction } = useContext(OwnerListingsActionContext)

  const { isApproved, isAvailable, UserContracts: userContracts } = room

  return (
    <DropDownMenu
      options={
        [
          {
            label: SEE_PLACE_DETAILS,
            onClick: () =>
              navigate(resolvePath(ROOM_DETAIL_PATH, { roomId: room.id })),
          },
          !isAvailable && userContracts?.length
            ? {
                label: EDIT_RENTAL_DETAILS,
                onClick: () => setAction({ name: 'edit_rental', room }),
              }
            : null,
          {
            label: EDIT_LISTING,
            onClick: () =>
              navigate(
                resolvePath(ME_OWNER_LISTING_EDIT_PATH, { roomId: room.id })
              ),
          },
          isApproved && isAvailable
            ? {
                label: MAKE_AS_RENTED,
                onClick: () => setAction({ name: 'make_as_rented', room }),
              }
            : null,
          !isAvailable
            ? {
                label: MAKE_AS_AVAILABLE,
                onClick: () => setAction({ name: 'make_as_available', room }),
              }
            : null,
          isAvailable
            ? {
                label: DELETE_LISTING,
                onClick: () => setAction({ name: 'delete_listing', room }),
              }
            : null,
        ].filter(Boolean) as MenuOption[]
      }
      dropDownProps={{
        labelClassName: 'text-12 text-medium text-nowrap',
        component: (
          <div className='px-8'>
            <EllipsisIcon size={12} />
          </div>
        ),
        alignment: 'right',
      }}
    />
  )
}

export default OwnerListingsAction
